import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

export interface UnselectTransplantDialogData {
  chainNumber: string;
  matchRunNumber: string;
}

export interface UnselectTransplantDialogResult {
  confirmed: boolean;
  reason?: string;
}

@Component({
  selector: 'app-unselect-transplant-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatSelectModule, FormsModule],
  template: `
    <h2 mat-dialog-title>Unselect Transplant Combination</h2>
    <mat-dialog-content>
      <p>
        Please provide a reason why this selected chain is being unselected for transplant.
      </p>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Unselect Reason*</mat-label>
        <mat-select [(ngModel)]="selectedReason" required>
          <mat-option value="A match was not accepted">A match was not accepted</mat-option>
          <mat-option value="Medical reasons">Medical reasons</mat-option>
          <mat-option value="Participant withdrew">Participant withdrew</mat-option>
          <mat-option value="Logistical issues">Logistical issues</mat-option>
          <mat-option value="Other">Other</mat-option>
        </mat-select>
      </mat-form-field>

      <p class="warning-note">
        <strong>Note:</strong> Do not forget to log possible inactivation or exclusion of participants
      </p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">Cancel</button>
      <button mat-raised-button color="warn" (click)="onConfirm()" [disabled]="!selectedReason">
        Confirm Unselect
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    mat-dialog-content {
      max-width: 600px;
      min-width: 500px;
      padding: 20px 24px;
    }
    mat-dialog-content p {
      margin-bottom: 16px;
      line-height: 1.5;
    }
    .full-width {
      width: 100%;
      margin: 24px 0;
    }
    .warning-note {
      color: #d32f2f;
      font-style: italic;
      font-size: 0.9rem;
      margin-top: 16px;
    }
    mat-dialog-actions {
      padding: 16px 24px;
    }
  `]
})
export class UnselectTransplantDialogComponent {
  selectedReason: string = '';

  constructor(
    public dialogRef: MatDialogRef<UnselectTransplantDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UnselectTransplantDialogData
  ) {}

  onCancel(): void {
    this.dialogRef.close({ confirmed: false });
  }

  onConfirm(): void {
    if (this.selectedReason) {
      this.dialogRef.close({
        confirmed: true,
        reason: this.selectedReason
      });
    }
  }
}
